module.exports = __webpack_public_path__ + "img/bg1.d82bc24b.png";